<template>
  <div
    :id="`popover-hover-button-${id}-${rank}-${index2}`"
    data-popover-trigger="hover"
    class="cursor-pointer border border-gray-300 text-left flex flex-row items-center hover:border-2 hover:border-gray-400"
    :class="{ 'h-24': condensed == undefined, 'h-16': condensed }"
    @mouseover="onHoverPopup(rank, index2, cell[week])"
  >
    <div class="w-full text-sm font-semibold h-full flex flex-row items-center px-3" :class="{ 'bg-green-100': isGreen(cell[week]), 'bg-gray-100': isGray(cell[week]) }">
      <div class="flex flex-row justify-between w-full" v-if="formatCell?.template != 'template-100'">
        <div class="w-6 flex justify-center items-center right"></div>

 

        <div class="w-full flex flex-row items-center justify-start">
          <div v-for="batch in meanTo2(cell[week])" :key="batch.id" class="flex flex-col px-2 text-gray-900 w-full">
            <div v-if="batch.status == 'OK'" class="text-base w-full flex justify-center items-center">
              <div class="flex flex-row text-gray-600 w-full">
                <div class=""><i class="fa-solid fa-temperature-half"></i> :</div>
                &nbsp; {{ formatTemperature(batch.temperature?.value) }} {{ batch.temperature?.unit }}
              </div>
              <div class="flex flex-row text-gray-600" v-if="formatCell?.show_humidity">
                <div class=""><i class="fa-regular fa-droplet"></i> :</div>
                <div class="p-1">:</div>
                <div class="">{{ formatHumidity(batch.humidity_rate?.value) }} {{ batch.humidity_rate?.unit }}</div>
              </div>
            </div>
            <div v-if="batch.status != 'OK'" class="font-normal text-gray-900 w-full flex justify-center items-center text-base">
               {{ batch.reason_label }}
            </div>
          </div>
        </div>
        <div class="w-9 flex justify-center items-center right">
          <div v-if="cell[week].length > 1" class="flex justify-center items-center bg-green-500 text-white rounded-full border border-green-700 p-1 font-bold text-xs w-8 h-8">
            +{{ cell[week].length - 1 }}
          </div>
        </div>
      </div>
    </div>
    <div
      :id="`popover-hover-menu-${id}-${rank}-${index2}`"
      data-popover
      role="tooltip"
      class="absolute z-10 invisible inline-block w-96 text-sm text-gray-500 transition-opacity duration-300 bg-white border border-gray-300 rounded-lg shadow-sm opacity-0   "
    >
      <FileColDisplayTemperatureHumidity v-if="formatCell?.template == 'template-105'" :items="cell[week]" />

      <div class="hidden py-1 bg-gray-50 border-t border-t-gray-300 text-xs justify-center font-normal h-full flex flex-row items-center px-3">
        <div class="cursor-pointer" @click="openDetails(cell)">
          <span>Voir le détail <i class="fa-solid fa-up-right-from-square pl-2 w-6" /></span>
        </div>
      </div>
      <div data-popper-arrow />
    </div>
  </div>
</template>

<script>
import { Popover } from "flowbite";

import FileColDisplayTemperatureHumidity from "@/components/five-col-cells/FileColDisplayTemperatureHumidity.vue";

export default {
  name: "CellTemperatureHumidity",

  components: {
    FileColDisplayTemperatureHumidity,
  },
  props: {
    cell: Object,
    week: String,
    condensed: Boolean,
    index2: Number,
    id: String,
    rank: Number,
    formatCell: Object,
  },

  data() {
    return {
      popupHoverSelection: null,
      comment: "",
    };
  },
  methods: {
    formatTemperature: function (value) {
      if (value == undefined) return "";
      if (value == "") return "";
      if (value == "null") return "";
      if (value == "--") return "";

      let valueF = parseFloat(value);

      return valueF.toFixed(2);
    },
    formatHumidity: function (value) {
      if (value == undefined) return "";
      if (value == "") return "";
      if (value == "null") return "";
      if (value == "--") return "";

      let valueF = parseFloat(value);

      return valueF.toFixed(2);
    },
    isGreen(ar) {
      if (ar == undefined) return false;
      if (ar.length == 0) return false;
      let arf = ar.filter(function (a) {
        return a.status == "OK";
      });
      return arf.length != 0;
    },
    isGray(ar) {
      if (ar == undefined) return false;
      if (ar.length == 0) return false;
      let arf = ar.filter(function (a) {
        return a.status == "KO";
      });
      return arf.length != 0;
    },
    displayDate(a) {
      if (a == "") return "-";

      let date = new Date(a);

      // Options pour formater la date
      const options = {
        day: "numeric", // Jour du mois (21)
        month: "numeric", // Nom complet du mois (Novembre)
        year: "numeric", // Année sur 2 chiffres (24)
      };

      // Formater la date en français
      const formattedDate = new Intl.DateTimeFormat("fr-FR", options).format(date);

      return formattedDate;
    },
    limitTo2(a, max) {
      if (a == undefined) return [];
      if (!Array.isArray(a)) return [];

      if (a.length < max) return a;

      return a.slice(0, max);
    },
    averageTemperature(data) {
      if (!data.length) return 0; // Retourne 0 si le tableau est vide

      // const totalTemperature = data.reduce((sum, item) => sum + item.temperature?.value, 0);
      // return totalTemperature / data.length;

      const average = (() => {
        const valid = data.map((item) => item.temperature?.value).filter((v) => v !== null && v !== undefined && v !== "");
        return valid.length ? valid.reduce((s, v) => s + v, 0) / valid.length : null;
      })();
      return average;
    },
    meanTo2(a) {
      if (a == undefined) return [];
      if (!Array.isArray(a)) return [];
      if (a.length == 0) return [];

      let m = this.averageTemperature(a);

      let b = [];
      let c = JSON.parse(JSON.stringify(a[0]));

      c.temperature = { value: m, unit: "°C" };
      b.push(c);

      return b;
    },
    formatDate(d) {
      if (d == undefined) return "";
      if (d == "") return "";
      let s = d.split("T");
      return s[0];
    },
    onHoverPopup(rank, index, items) {
   

      this.comment = "id =" + index;
      if (items == undefined) return;
      if (items.length == 0) return;

      if (this.popupHoverSelection == undefined) {
    

        // set the popover content elementpopover-default-pv2-28
        const $targetEl = document.getElementById("popover-hover-menu-" + this.id + "-" + rank + "-" + index);
        if ($targetEl == undefined) {
 

          return;
        }
        // set the element that trigger the popover using hover or click
        const $triggerEl = document.getElementById("popover-hover-button-" + this.id + "-" + rank + "-" + index);
        if ($triggerEl == undefined) {
 

          return;
        }
        // options with default values
        const options = {
          placement: "bottom",
          triggerType: "hover",
          offset: 10,
        //  onHide: () => {
     
        //  },
        //  onShow: () => {
 
        //  },
        //  onToggle: () => {
   
        //  },
        };

        // instance options object
        const instanceOptions = {
          id: "popover-hover-menu-" + this.id + rank + "-" + "-" + index, //'popover-hover',
          override: true,
        };

        this.popupHoverSelection = new Popover($targetEl, $triggerEl, options, instanceOptions);
      } else {
     
        if (this.popupHoverSelection != undefined) this.popupHoverSelection.show();
      }
    },
  },
};
</script>
